import {
    SHOW_LOGIN,
    HIDE_LOGIN,
    SET_LOGIN_OFFSET_TOP,
    SET_LOGIN_SPINNER_ORIGIN,
    SHOW_LOGIN_SPINNER,
    HIDE_LOGIN_SPINNER,
    HIDE_SSO_EMAIL_ERROR_MODAL,
    SHOW_SSO_EMAIL_ERROR_MODAL,
} from '../constants/ActionTypes';

export const showEmailLogin = () => ({
    type: SHOW_LOGIN,
});

export const hideEmailLogin = () => ({
    type: HIDE_LOGIN,
});

export const showLoginV2Spinner = () => ({
    type: SHOW_LOGIN_SPINNER,
});

export const hideLoginV2Spinner = () => ({
    type: HIDE_LOGIN_SPINNER,
});

export const setLoginV2OffsetTop = payload => ({
    type: SET_LOGIN_OFFSET_TOP,
    payload,
});

export const setLoginV2SpinnerOrigin = payload => ({
    type: SET_LOGIN_SPINNER_ORIGIN,
    payload,
});

export const hideSsoEmailErrorModal = () => ({
    type: HIDE_SSO_EMAIL_ERROR_MODAL,
});

export const showSsoEmailErrorModal = payload => ({
    type: SHOW_SSO_EMAIL_ERROR_MODAL,
    payload,
});


